import { createFileRoute } from "@tanstack/react-router";

import { SimulationRunsPage } from "../../../workspaces/worlds/pages/SimulationRunsPage";
import { trimmedStringParam } from "../../../lib/url-state";

export const Route = createFileRoute("/_console/p/$org/$project/simulate/runs")(
  {
    validateSearch: (
      search: Record<string, unknown>,
    ): { run?: string; kind?: "generation" } => ({
      run: trimmedStringParam(search.run),
      kind: search.kind === "generation" ? "generation" : undefined,
    }),
    component: RunsRoute,
  },
);

function RunsRoute() {
  const { run, kind } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SimulationRunsPage
      selectedRun={run}
      selectedKind={kind}
      onSelectRun={(selected, selectedKind) =>
        void navigate({
          search: {
            run: selected ?? undefined,
            kind: selectedKind === "generation" ? "generation" : undefined,
          },
        })
      }
    />
  );
}
